"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = FormContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _authentication = require("../../../../types/authentication");
var _validation = require("../../../../utils/validation");
var _InputField = require("../../../../components/InputField");
var _ContentLayout = require("../../../../components/ContentLayout");
var _view = require("../../../../types/view");
var _keyCodes = require("../../../../types/keyCodes");
var _FieldGroupLayout = require("../../../../components/FieldGroupLayout");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function FormContainer(_ref) {
  let {
    initialEmail,
    error,
    status,
    source,
    changeView,
    restore
  } = _ref;
  const emailRef = React.useRef(null);
  const [email, setEmail] = React.useState(initialEmail);
  const [touched, setTouched] = React.useState(false);
  const [changed, setChanged] = React.useState(!!error);
  const [isEmailInValid, setEmailInvalid] = React.useState((0, _validation.isEmail)(email));
  const handleChangeEmail = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    setEmail(value);
    setChanged(true);
    setEmailInvalid(!!value && !(0, _validation.isEmail)(value));
  }, []);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    if (!email || !(0, _validation.isEmail)(email) || status === _authentication.ERestoreStatus.Loading) {
      if (emailRef.current) {
        emailRef.current.focus();
      }
      return;
    }
    restore(email, source);
  }, [email, status, source, restore]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  const switchToRegister = React.useCallback(() => {
    changeView(_view.EActiveView.AuthenticationRegistration);
  }, [changeView]);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(_InputField.InputField, {
      "data-name": "EmailInput",
      autoFocus: true,
      name: "email",
      ref: emailRef,
      onChange: handleChangeEmail,
      onKeyDown: handleSubmitOnEnter,
      placeholder: "Email",
      invalid: touched && (status === _authentication.ERestoreStatus.Failed && !changed || isEmailInValid),
      errorMessage: touched && status === _authentication.ERestoreStatus.Failed && !changed ? error : undefined,
      value: email,
      disabled: status === _authentication.ERestoreStatus.Loading
    }),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueAuthBtn",
      theme: "fill_primary",
      fullWidth: true,
      disabled: status === _authentication.ERestoreStatus.Loading,
      loading: status === _authentication.ERestoreStatus.Loading,
      onClick: handleSubmit
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "CreateAccountBtn",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: switchToRegister
    }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442"))
  })));
}